module.exports = __webpack_public_path__ + "static/media/Mothim_gaussian2.f8942c00.png";